import React, { createContext, useContext, ReactNode } from 'react';
import { useAllSignalsState } from './use-all-signals-state';

const AllSignalsContext = createContext<ReturnType<
  typeof useAllSignalsState
> | null>(null);

interface AllSignalsProviderProps {
  children: ReactNode;
}

export const AllSignalsProvider = ({ children }: AllSignalsProviderProps) => {
  const state = useAllSignalsState();

  return (
    <AllSignalsContext.Provider value={state}>
      {children}
    </AllSignalsContext.Provider>
  );
};

export const useAllSignalsContext = () => {
  const context = useContext(AllSignalsContext);

  if (!context) {
    throw new Error(
      'useAllSignalsContext must be used within an AllSignalsProvider',
    );
  }

  return context;
};
